import {DayPartingSelector, WEEKDAYS} from './DayPartingSelector'
import {FormCard} from 'common/components/FormCard'
import {CalendarOutlined} from '@ant-design/icons'
import {Button, Col, Row} from 'antd'
import {ReactNode, useState} from 'react'

interface BudgetFormCardProps {
    id: string
    title: ReactNode
    dayParting: number[][]
    setDayParting: (val: any) => void
}

const DayPartingCard: React.FC<BudgetFormCardProps> = ({
                                                           id, title,
                                                           dayParting,
                                                           setDayParting,
                                                       }) => {
    const [selectorVisible, setSelectorVisible] = useState(false)

    const formatSelectedHours = (hours: number[]): string => {
        if (!hours) {
            return 'not selected'
        }

        if (hours.length !== 24) {
            throw new Error('Input must be an array of 24 elements')
        }

        if (hours.every(h => h === 1)) {
            return 'full day'
        }

        if (hours.every(h => h === 0)) {
            return 'not selected'
        }

        const result: string[] = [];
        let start: number | null = null;

        for (let i = 0; i <= 24; i++) {
            if (hours[i] === 1 && start === null) {
                start = i;
            }

            if ((hours[i] !== 1 || i === 24) && start !== null) {
                const from = start.toString().padStart(2, '0') + ':00';
                const to = i.toString().padStart(2, '0') + ':00';
                result.push(`${from} - ${to}`);
                start = null;
            }
        }

        return result.join(', ');
    }

    return <FormCard id={id} title={title}>
        {WEEKDAYS.map((day, i) => <Row style={{marginBottom: 10}} key={`${day}_row`}>
            <Col span="4" style={{textAlign: 'right', paddingRight: 16}}><span>{day}</span></Col>
            <Col span="12"><span style={{color: '#6F757E'}}>{formatSelectedHours(dayParting[i])}</span></Col>
        </Row>)}
        <Row>
            <Col span="4"></Col>
            <Col span="12">
                <Button type="primary" ghost onClick={() => setSelectorVisible(true)}>
                    <CalendarOutlined/> Set days and hours
                </Button>
            </Col>
        </Row>

        <DayPartingSelector
            dayParting={dayParting}
            setDayParting={setDayParting}
            visible={selectorVisible}
            setVisible={setSelectorVisible}
        />
    </FormCard>
};

export default DayPartingCard;
